var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleVacation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,3.5 A2.5,2.5 0 1,1 6,8.5 A2.5,2.5 0 1,1 6,3.5 Z M6,3.82 A2.18,2.18 0 1,0 6,8.18 A2.18,2.18 0 1,0 6,3.82 Z M5.84,0.5 H6.16 V2.5 H5.84 Z M5.84,9.5 H6.16 V11.5 H5.84 Z M0.5,5.84 H2.5 V6.16 H0.5 Z M9.5,5.84 H11.5 V6.16 H9.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleVacation);
export default __webpack_public_path__ + "static/media/icon_module_vacation.dec340051bddf5cdfd5b52507e96e417.svg";
export { ForwardRef as ReactComponent };